import request from '@/utils/request'

export async function getData(data) {
  return request({
    url: '/equipment/truckScales/list',
    method: 'post',
    data,
  })
}
export async function getDetail(data) {
  return request({
    url: '/equipment/truckScales/detail',
    method: 'get',
    params: data,
  })
}
export async function createData(data) {
  return request({
    url: '/equipment/truckScales/save',
    method: 'post',
    data,
  })
}
export async function updateData(data) {
  return request({
    url: '/equipment/truckScales/edit',
    method: 'post',
    data,
  })
}
export async function deleteData(data) {
  return request({
    url: '/equipment/truckScales/delete',
    method: 'post',
    data,
  })
}
